var React = require( 'react' );
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');

var BodyOverlay = createReactClass({

	getDefaultProps: function(){
		return {
			gender: 'male',
			activeBodyParts: ''
		}
	},

	render: function(){
		// console.log(this.props.gender + ' ' + this.props.activeBodyParts)
		return (
			<div className="large-5 small-12 column">
				<div id="body-container">
					<div id="overlay" className={this.props.gender + ' ' + this.props.activeBodyParts}>
						<div className="layer mouth-and-esophagus"></div>
						<div className="layer stomach"></div>
						<div className="layer colon"></div>
						<div className="layer small-bowel"></div>
						<div className="layer rectum-anus"></div>
					</div>
				</div>
			</div>
		)
	}
});

BodyOverlay.propTypes = {
	gender: PropTypes.string,
	activeBodyParts: PropTypes.string
};

module.exports = BodyOverlay;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/bodyOverlay.jsx